{
  "moving-estimate-checklist": {
    "packId": "moving",
    "title": "이사 견적서 18항목 체크리스트",
    "body": [
      "총액·VAT부터 사다리차·계단·짐 목록·취소·파손 접수까지 18개를 같은 순서로 확인해요.",
      "이 기준은 추가금과 작업 조건을 확인하기 위한 보조 목록이며 표준약관의 모든 필수 기재사항을 인증하거나 법률 판단하지 않아요."
    ],
    "description": "총액·VAT부터 사다리차·계단·짐 목록·취소·파손 접수까지 18개를 같은 순서로 확인해요.",
    "next": "/new?pack=moving"
  },
  "moving-extra-fee": {
    "packId": "moving",
    "title": "이사 견적보다 돈을 더 달라고 할 때, 계약 전에 확인할 7가지",
    "body": [
      "부가세·사다리차·계단·주차 거리·추가 짐·작업 인원·취소 조건을 포함인지 별도인지 나눠 물어봐요.",
      "별도라면 금액과 적용 조건을 함께 받아야 당일에 같은 말을 확인하기 쉬워요."
    ],
    "description": "부가세·사다리차·계단·주차 거리·추가 짐·작업 인원·취소 조건을 포함인지 별도인지 나눠 물어봐요.",
    "next": "/new?pack=moving"
  },
  "ladder-truck": {
    "packId": "moving",
    "title": "사다리차 별도라는 말에 빠진 질문",
    "body": [
      "출발지와 도착지 비용을 따로 확인하고 층수·차량 접근·취소 조건을 함께 물어봐요.",
      "적힌대로는 필요한 금액 항목을 짚을 뿐 적정한 사다리차 가격을 판단하지 않아요."
    ],
    "description": "출발지와 도착지 비용을 따로 확인하고 층수·차량 접근·취소 조건을 함께 물어봐요.",
    "next": "/new?pack=moving"
  },
  "cleaning-scope-checklist": {
    "packId": "cleaning",
    "title": "청소 계약서에서 범위와 추가금을 확정하는 22가지",
    "body": [
      "가사근로자법 제11조와 시행규칙 제6조는 이용계약서에 서비스 종류·내용·제공일·시간·요금·변경 절차·취소·손해배상·분쟁 해결까지 적도록 정하고 있어요. 이 기준은 인증받은 가사서비스 제공기관과의 계약에 적용돼요.",
      "중개 플랫폼으로 개인과 맺는 계약에는 이 법이 적용되지 않을 수 있어요. 그래서 적힌대로는 계약 상대를 먼저 확인하고, 적용되지 않는 경우에는 같은 항목을 참고 기준으로만 보여줘요.",
      "창틀·가전 내부·면적 기준처럼 현장에서 말이 갈리는 항목을 먼저 확인하도록 표시해요. 적힌대로는 위법 여부나 배상 책임을 판단하지 않아요."
    ],
    "description": "가사근로자법 제11조와 시행규칙 제6조는 이용계약서에 서비스 종류·내용·제공일·시간·요금·변경 절차·취소·손해배상·분쟁 해결까지 적도록 정하고 있어요. 이 기준은 인증받은 가사서비스 제공기관과의 계약에 적용돼요.",
    "next": "/new?pack=cleaning"
  },
  "cleaning-extra-fee": {
    "packId": "cleaning",
    "title": "청소 당일 추가금, 계약서 어디를 보면 되나요",
    "body": [
      "현장 추가금은 대부분 기본 범위에서 빠진 작업이에요. 창틀·방충망·냉장고 내부·베란다처럼 자주 빠지는 항목부터 포함인지 별도인지 물어봐요.",
      "면적과 방 개수 기준이 실제와 다르면 금액이 달라져요. 몇 평 기준인지와 다를 때 어떻게 처리하는지를 계약 전에 받아 두면 당일에 같은 말을 확인하기 쉬워요."
    ],
    "description": "현장 추가금은 대부분 기본 범위에서 빠진 작업이에요. 창틀·방충망·냉장고 내부·베란다처럼 자주 빠지는 항목부터 포함인지 별도인지 물어봐요.",
    "next": "/new?pack=cleaning"
  },
  "moving-cancel-postpone": {
    "packId": "moving",
    "title": "이사업체가 취소·연기를 말했을 때 먼저 남길 5가지",
    "body": [
      "받은 시각, 카톡·문자 원문, 원래 이사일, 바뀐 날짜, 이미 낸 계약금을 먼저 한곳에 남겨요. 통지를 요약하면 나중에 시점과 표현이 달라질 수 있어 원문을 그대로 보관하는 편이 안전해요.",
      "찾기쉬운 생활법령은 이사화물 약관의 계약해제·계약금 반환·손해배상 기준을 안내해요. 실제 적용은 계약 내용과 통지 주체·시점에 따라 달라질 수 있으므로 적힌대로는 액수나 책임을 자동 계산하지 않아요."
    ],
    "description": "받은 시각, 카톡·문자 원문, 원래 이사일, 바뀐 날짜, 이미 낸 계약금을 먼저 한곳에 남겨요. 통지를 요약하면 나중에 시점과 표현이 달라질 수 있어 원문을 그대로 보관하는 편이 안전해요.",
    "next": "/new?pack=moving"
  },
  "moving-settlement-receipt": {
    "packId": "moving",
    "title": "이사 계약금·잔금·추가금·환불을 맞추는 기록법",
    "body": [
      "계약금, 잔금, 추가금, 환불을 실제 오간 날과 금액으로 따로 적고 영수증·이체확인증을 받았는지 표시해요. 계좌번호나 카드번호는 기록하지 않아도 돼요.",
      "찾기쉬운 생활법령은 이사 계약서에 계약금과 운임 잔액을 적고, 이사 방식에 따른 완료 확인 뒤 잔금을 지급하는 기준을 안내해요. 적힌대로는 지급 사실과 증빙 상태만 묶고 적정 금액이나 환급 의무를 판단하지 않아요."
    ],
    "description": "계약금, 잔금, 추가금, 환불을 실제 오간 날과 금액으로 따로 적고 영수증·이체확인증을 받았는지 표시해요. 계좌번호나 카드번호는 기록하지 않아도 돼요.",
    "next": "/new?pack=moving"
  },
  "moving-checklist-template": {
    "title": "이사 체크리스트 양식 · 18개 빈칸",
    "packId": "moving",
    "body": [
      "받은 견적이 없어도 업체에 물을 18개 항목을 인쇄하거나 CSV로 받아요.",
      "계약 원문과 업체가 답한 내용을 직접 확인해 주세요. 공공 상담은 1372 소비자상담센터를 이용할 수 있어요."
    ],
    "description": "받은 견적이 없어도 업체에 물을 18개 항목을 인쇄하거나 CSV로 받아요.",
    "next": "/new?pack=moving"
  },
  "cleaning-checklist-template": {
    "title": "입주청소 체크리스트 양식 · 22개 빈칸",
    "packId": "cleaning",
    "body": [
      "청소 범위와 별도 금액을 같은 양식으로 받아요. 인증기관과 중개 계약의 적용 기준은 달라요.",
      "계약 원문과 업체가 답한 내용을 직접 확인해 주세요. 공공 상담은 1372 소비자상담센터를 이용할 수 있어요."
    ],
    "description": "청소 범위와 별도 금액을 같은 양식으로 받아요. 인증기관과 중개 계약의 적용 기준은 달라요.",
    "next": "/new?pack=cleaning"
  },
  "moving-contract-checklist": {
    "title": "이사 계약서, 서명 전에 확인할 것",
    "packId": "moving",
    "body": [
      "마지막 계약서의 총액·날짜·별도 금액을 지금까지 받은 견적과 같은 줄에서 맞춰 보세요.",
      "계약 원문과 업체가 답한 내용을 직접 확인해 주세요. 공공 상담은 1372 소비자상담센터를 이용할 수 있어요."
    ],
    "description": "마지막 계약서의 총액·날짜·별도 금액을 지금까지 받은 견적과 같은 줄에서 맞춰 보세요.",
    "next": "/new?pack=moving"
  },
  "moving-estimate-how": {
    "title": "이삿짐 견적 받기 전에 준비할 짐 목록",
    "packId": "moving",
    "body": [
      "냉장고·세탁기·침대·박스 수와 계단·주차 거리를 같은 기준으로 알려 주세요.",
      "계약 원문과 업체가 답한 내용을 직접 확인해 주세요. 공공 상담은 1372 소비자상담센터를 이용할 수 있어요."
    ],
    "description": "냉장고·세탁기·침대·박스 수와 계단·주차 거리를 같은 기준으로 알려 주세요.",
    "next": "/new?pack=moving"
  },
  "moving-day-checklist": {
    "title": "이사 당일 체크리스트",
    "packId": "moving",
    "body": [
      "현장에서 추가금 얘기가 나오면 견적과 회신 원문부터 다시 열어 보세요. 인터넷이 없을 때를 대비해 미리 열어 두세요.",
      "계약 원문과 업체가 답한 내용을 직접 확인해 주세요. 공공 상담은 1372 소비자상담센터를 이용할 수 있어요."
    ],
    "description": "현장에서 추가금 얘기가 나오면 견적과 회신 원문부터 다시 열어 보세요. 인터넷이 없을 때를 대비해 미리 열어 두세요.",
    "next": "/new?pack=moving"
  },
  "moving-damage": {
    "title": "이사 뒤 파손을 발견했다면 남길 사실",
    "packId": "moving",
    "body": [
      "발견한 시각·장소·상태를 사진과 함께 남기고 업체에 확인할 내용을 적어요. 책임이나 보상액은 자동 판단하지 않아요.",
      "계약 원문과 업체가 답한 내용을 직접 확인해 주세요. 공공 상담은 1372 소비자상담센터를 이용할 수 있어요."
    ],
    "description": "발견한 시각·장소·상태를 사진과 함께 남기고 업체에 확인할 내용을 적어요. 책임이나 보상액은 자동 판단하지 않아요.",
    "next": "/new?pack=moving"
  },
  "moving-no-show": {
    "title": "이사업체가 안 오거나 연락이 안 될 때",
    "packId": "moving",
    "body": [
      "약속한 시각, 연락한 시각과 받은 말을 먼저 남기세요. 실제 지급한 금액은 정산 기록에 따로 적어요.",
      "계약 원문과 업체가 답한 내용을 직접 확인해 주세요. 공공 상담은 1372 소비자상담센터를 이용할 수 있어요."
    ],
    "description": "약속한 시각, 연락한 시각과 받은 말을 먼저 남기세요. 실제 지급한 금액은 정산 기록에 따로 적어요.",
    "next": "/new?pack=moving"
  }
}
